import styled from 'styled-components';
import CustomButton from '~/components/layout/CustomButton';
import CustomCheckBox from '~/components/layout/CustomCheckBox';

export const WrapItems = styled.div`
  display: flex;
  flex-direction: column;
  align-items: self-start;
  max-width: 80%;
  margin-top: 42px;

  @media(max-width: 600px) {
    max-width: 95%;
  }
`;

export const Container = styled.div`
  margin-top: 8px;
  display: flex;
  width: 100%;
  align-items: center;
  justify-content: space-between;

  @media (max-width: 800px) {
    flex-direction: column;
    align-items: flex-start;
    justify-content: flex-start;
    flex-direction: column-reverse;
  }
`;

export const CheckBoxWrap = styled.div`
  display: flex;
  margin-top: 8px;

  @media(max-width: 800px) {
    margin-top: 18px;
  }
`;

export const CheckBox = styled(CustomCheckBox)``;

export const CheckBoxText = styled.span`
  margin-left: 23px;
  margin-bottom: 8px;
  font-family: 'Mangueira', sans-serif;
  font-size: 14px;
  line-height: 19px;
  color: rgba(122, 122, 122, 0.87);
`;

export const WrapButtons = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  margin-left: auto;

  @media (max-width: 800px) {
    margin-left: unset;
  }
`

export const ButtonDownload = styled(CustomButton)`
  max-width: 170px;
  max-height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;

  @media (max-width: 600px) {
    max-width: 150px;
    max-height: 35px;
    font-size: 13px;
  }
`;

export const ButtonEmail = styled(ButtonDownload)`
  margin-left: 16px;

  @media (max-width: 600px) {
    margin-left: 8px;
  }
`;

export const Separator = styled.div`
  margin-top: 16px;
  border: 1px dashed rgba(0, 0, 0, 0.1);
`
